import { Grid, Button, CardMedia } from "@mui/material";
import React, { memo, useEffect, useState } from "react";
import ButtonRight from "../../components/BoxRightContent/ButtonRight";
import BoxLeftContent from "../../components/BoxLeftContent/BoxLeftContent";
import clsx from "clsx";
import Configs from "../../constants/Configs";
import {
  getData,
  storeData,
  clearData,
  checkEditPage,
  callChoice,
  addWarterMarker,
  setHash,
} from "../../utils/GlobalHelper";
import HeaderRight from "../../components/BoxRightContent/HeaderRight";
import HeaderPage from "../../components/HeaderPage/Index";
import { isMobile } from "react-device-detect";
import Loading from "../../components/loading/loading";
import ScrollBarComponent from "../../components/BoxRightContent/ScrollBarComponent";
import { styled } from "@mui/system";
import { isEmpty } from "lodash";
import DialogWait from "../../components/CustomDialog/DialogWait";
import GlobalApi from "../../utils/GlobalApi";
import qs from "qs";
import { loadImage } from "canvas";

const header = {
  headers: {
    "Content-Type": "application/x-www-form-urlencoded",
    Accept: "application/json",
  },
};
const Input = styled("input")({
  display: "none",
});
const AttachSign = (props) => {
  const head_token = getData("HeaderManp")
    ? getData("HeaderManp")?.head_token
    : "";
  const [lang, setLang] = useState(getData("lang"));
  const [translations, setTranslations] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [uploadFileRef, setUploadFileRef] = useState("");
  const [isCheck, setIsCheck] = useState(false);
  const [isModelWait, setIsModelWait] = useState(false);
  const [isModelWaitText, setIsModelWaitText] = useState({
    title: "",
    massage: "",
    btn: "",
  });
  const mb = isMobile ? 16 : 9;
  const [editUrl, setEditUrl] = useState(false);
  const [jumpPage, setJumpPage] = useState(false);
  const checkuserinfo = getData("checkuserinfo");
  const questions = getData("questionsAnswer");
  const pageAgree = getData("page_agree");
  const idc = getData("idc");
  const idcAddr = getData("f2_idc_address");
  const curAddr = getData("f2_current_address");
  const workAddr = getData("f2_workplace_address");
  const docAddr = getData("f2_document_address");
  const suit = getData("suitability");
  const status = getData("family_status");
  const childList = getData("childList");
  const career = getData("f3_career");
  const income = getData("f3_source_income");
  const purpose = getData("f3_purpose_invest");
  const asset = getData("f3_asset");
  let snapIdCard = getData("uploadImage");

  const checkJumpPage = async () => {
    await getImageSnapIdCard();
    let productChoice = false;
    await callChoice(head_token).then((res) => {
      if (!isEmpty(res)) {
        res.forEach((e) => {
          e.items.forEach((item) => {
            if (item.selected === 1) productChoice = true;
          });
        });
      }
    });

    if (
      isEmpty(checkuserinfo) ||
      isEmpty(questions) ||
      isEmpty(pageAgree) ||
      pageAgree.termandcon !== 1 ||
      pageAgree.pdpa !== 1 ||
      isEmpty(snapIdCard) ||
      isEmpty(idc) ||
      isEmpty(idcAddr) ||
      isEmpty(curAddr) ||
      isEmpty(workAddr) ||
      isEmpty(docAddr) ||
      isEmpty(career) ||
      !productChoice ||
      isEmpty(suit) ||
      isEmpty(status) ||
      isEmpty(childList?.data) ||
      isEmpty(income) ||
      isEmpty(purpose) ||
      isEmpty(asset)
    ) {
      return true;
    } else {
      return false;
    }
  };
  const getImageSnapIdCard = async () => {
    setIsLoading(true);
    var postData = {
      head_token,
    };
    const header = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const queryString = new URLSearchParams(postData).toString();
    let getImage_url = `${Configs.baseURL}/api/getupload?` + queryString;
    try {
      await GlobalApi.get(getImage_url, header)
        .then(async (res) => {
          setIsLoading(false);
          if (res.data.api_status === "1") {
            if (res.data.data.length > 0) {
              res.data.data.forEach((element) => {
                if (element.tb_image_page === "uploadImage") {
                  snapIdCard = element.tb_image_type + element.tb_image_base64;
                }
              });
            }
          }
        })
        .catch((er) => {
          setIsLoading(false);
        });
    } catch (error) {
      setIsLoading(false);
    }
    return;
  };
  const checkEditUrl = async () => {
    checkEditPage().then((res) => {
      res ? setEditUrl(true) : setEditUrl(false);
    });
  };
  let stampUpload = getData("stampUpload")
    ? getData("stampUpload")
    : {
        uploadImage: false,
        eSignature: false,
        uploadImageBookBank: false,
      };
  const saveImage = async () => {
    const uploadImageSign = uploadFileRef ? uploadFileRef : "";
    const uploadImage_str = uploadImageSign.split("data:image/jpeg;base64,");
    const hashData = setHash(uploadImageSign);
    const watermark_image = await addWarterMarker(uploadImageSign, false, "");
    try {
      var postData = {
        head_token,
        base64: uploadImage_str[1],
        type: "data:image/jpeg;base64,",
        key: "eSignature",
        hash: hashData,
        watermark_image: watermark_image,
      };
      await GlobalApi.post(
        `${Configs.baseURL}/api/upload`,
        qs.stringify(postData),
        header,
      )
        .then(async (res) => {
          // setIsLoading(false);
          clearData("uploadImageSign");
          stampUpload.eSignature = true;
          await storeData("stampUpload", stampUpload);
        })
        .catch((er) => {
          // console.log(er);
          setIsLoading(false);
          setIsModelWait(true);
        });
    } catch (error) {
      // console.log(error);
      setIsLoading(false);
      setIsModelWait(true);
    }
    return;
  };
  const getImage = async () => {
    setIsLoading(true);
    var postData = {
      head_token,
      key: "eSignature",
    };
    const queryString = new URLSearchParams(postData).toString();
    let getImage_url = `${Configs.baseURL}/api/getupload?` + queryString;
    try {
      await GlobalApi.get(getImage_url, header)
        .then((res) => {
          setIsLoading(false);
          if (res.data.api_status !== "0") {
            if (res.data.data[0].head_token === head_token) {
              let imsSrc =
                res.data.data[0].tb_image_type +
                res.data.data[0].tb_image_base64;
              setUploadFileRef(imsSrc);
            }
          }
        })
        .catch((er) => {
          // console.log(er);
          setIsLoading(false);
          setIsModelWait(true);
        });
    } catch (error) {
      // console.log(error);
      setIsLoading(false);
      setIsModelWait(true);
    }
    return;
  };
  const handleNext = async () => {
    //TODO function nextPage
    const base64 = await addWarterMarker(uploadFileRef, false, "");
    // console.log(base64);
    if (isEmpty(head_token)) {
      checkEditPage().then((res) => {
        if (res) {
          //setIsLoading(true);
          const formData = new FormData();
          formData.append("eSignature", base64);
          formData.append("head_token", head_token);
          formData.append("f10_docf_id", "4");
          formData.append("f10_doct_id", "4");
          const header = {
            headers: {
              "Content-Type": "application/json",
            },
          };
          try {
            GlobalApi.post(
              `${Configs.baseAPIURL03}/form/document/upload`,
              formData,
              header,
            )
              .then(async (res) => {
                //  setIsLoading(false);
                if (res.data.Data[0][0].IsSuccess === 1) {
                  await saveImage();
                  await storeData("editPage", "attach_sign");
                  await props.history.push("/summary");
                }
              })
              .catch((e) => {
                setIsLoading(false);
              });
          } catch (error) {
            setIsLoading(false);
          }
        } else {
          props.history.push("/IdcForm");
        }
      });
    } else {
      checkEditPage().then((res) => {
        if (res) {
          setIsLoading(true);
          const formData = new FormData();
          formData.append("eSignature", base64);
          formData.append("head_token", head_token);
          formData.append("f10_docf_id", "4");
          formData.append("f10_doct_id", "4");
          const header = {
            headers: {
              "Content-Type": "application/json",
            },
          };
          try {
            GlobalApi.post(
              `${Configs.baseAPIURL03}/form/document/upload`,
              formData,
              header,
            )
              .then(async (res) => {
                // setIsLoading(false);
                if (res.data.Data[0][0].IsSuccess === 1) {
                  // from summary page
                  await saveImage();
                  await storeData("editPage", "attach_sign");
                  await props.history.push("/summary");
                }
              })
              .catch((e) => {
                setIsModelWaitText({
                  ...isModelWaitText,
                  massage: e,
                });
                setIsLoading(false);
              });
          } catch (error) {
            setIsModelWaitText({
              ...isModelWaitText,
              massage: error,
            });
            setIsLoading(false);
          }
        } else {
          setIsLoading(true);
          const formData = new FormData();
          formData.append("eSignature", base64);
          formData.append("head_token", head_token);
          formData.append("f10_docf_id", "4");
          formData.append("f10_doct_id", "4");
          const header = {
            headers: {
              "Content-Type": "application/json",
            },
          };
          try {
            GlobalApi.post(
              `${Configs.baseAPIURL03}/form/document/upload`,
              formData,
              header,
            )
              .then(async (res) => {
                //setIsLoading(false);
                if (res.data.Data[0][0].IsSuccess === 1) {
                  await saveImage();
                  await props.history.push("/ats_list");
                }
              })
              .catch((e) => {
                setIsModelWaitText({
                  ...isModelWaitText,
                  massage: e,
                });
                setIsLoading(false);
              });
          } catch (error) {
            setIsModelWaitText({
              ...isModelWaitText,
              massage: error,
            });
            setIsLoading(false);
          }
          return;
        }
      });
    }
  };
  const uploadFile = (e) => {
    const file = e.target.files[0];
    if (!file) {
      return;
    }
    if (parseFloat(file.size / 1024 / 1024) > 10) {
      setIsModelWaitText({
        title: translations?.[lang]?.snapidcard?.alert_upload?.title,
        massage: translations?.[lang]?.snapidcard?.alert_upload?.massage,
        btn: translations?.[lang]?.snapidcard?.alert_upload?.btn,
      });
    } else {
      var fileTypes = ["jpg", "jpeg", "png"];
      var extension = file.name.split(".").pop().toLowerCase(), //file extension from input file
        isSuccess = fileTypes.indexOf(extension) > -1; //is extension in acceptable types
      if (isSuccess) {
        setIsLoading(true);
        const reader = new FileReader();
        reader.addEventListener(
          "load",
          function () {
            let imgSrc = reader.result;
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");
            const imgMark = new Image();
            imgMark.src = "/images/waterMark2.png?v=4";
            loadImage(imgSrc)
              .then(async (image) => {
                const maxW = 1200;
                const maxH = 1200;
                const iw = image.width;
                const ih = image.height;
                const scale = Math.min(maxW / iw, maxH / ih);
                const iwScaled = iw * scale;
                const ihScaled = ih * scale;
                canvas.width = iwScaled;
                canvas.height = ihScaled;
                ctx.fillStyle = "rgb(255, 255, 255)";
                ctx.fillRect(0, 0, canvas.width, canvas.height);
                ctx.drawImage(image, 0, 0, iwScaled, ihScaled);
                //ctx.drawImage(imgMark, 0, 0, iwScaled, ihScaled);
                setUploadFileRef(canvas.toDataURL("image/jpeg", 0.5));
                setIsLoading(false);
              })
              .catch((e) => {
                setIsLoading(false);
                return;
              });
          },
          false,
        );

        if (file) {
          reader.readAsDataURL(file);
        }
      } else {
        setIsModelWaitText({
          title:
            translations?.[lang]?.snapidcard?.alert_upload_file_type?.title,
          massage:
            translations?.[lang]?.snapidcard?.alert_upload_file_type?.massage,
          btn: translations?.[lang]?.snapidcard?.alert_upload_file_type?.btn,
        });
      }
    }
  };
  useEffect(() => {
    checkJumpPage().then((res) => {
      if (res) setJumpPage(true);
    });
  }, []);
  useEffect(() => {
    checkEditUrl();
    if (!isEmpty(uploadFileRef)) {
      setIsCheck(true);
    }
  }, [uploadFileRef]);
  useEffect(() => {
    if (!isEmpty(isModelWaitText.title)) setIsModelWait(true);
  }, [isModelWaitText]);
  useEffect(() => {
    if (stampUpload.eSignature) {
      getImage();
    }
    const translation = getData("Translations");
    if (!isEmpty(translation)) {
      setTranslations(translation);
    } else {
      props.history.push("/");
    }
  }, []);
  const clickBack = () => {
    const back_form_ats = getData("back_form_ats")
      ? getData("back_form_ats")
      : "";
    if (!back_form_ats) {
      clearData("uploadImageSign");
    }
    props.history.push("/example_sign");
  };
  return (
    <>
      {jumpPage ? (
        <Grid className="app-splash-screen"></Grid>
      ) : (
        <>
          <HeaderPage
            title={translations?.[lang]?.sign?.title}
            onChangeLang={(e) => setLang(e)}
            clickBack={(e) => (e ? clickBack() : "")}
          />
          <DialogWait
            open={isModelWait}
            isModel={setIsModelWait}
            title={isModelWaitText.title}
            massage={isModelWaitText.massage}
            btn={isModelWaitText.btn}
          />
          <Loading status={isLoading} />
          <Grid className="background-bg">
            <Grid className="section-consent">
              <Grid className={isMobile ? "box-content-mb" : "box-content"}>
                <Grid container className="box-content-main" columns={16}>
                  {!isMobile && (
                    <Grid item xs={7} className="box-left">
                      <BoxLeftContent
                        translations={translations?.[lang]?.sign}
                        clickBack={(e) => clickBack()}
                        editUrl={editUrl}
                      />
                    </Grid>
                  )}
                  <Grid
                    item
                    xs={mb}
                    className={isMobile ? "box-right-mb" : "box-right"}
                  >
                    <Grid className="content">
                      <Grid className="content-main">
                        <Grid
                          className="box-right-content pb-3"
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            height: "100%",
                          }}
                        >
                          {" "}
                          <HeaderRight
                            title={translations?.[lang]?.sign?.title}
                          />
                          <ScrollBarComponent
                            content={
                              <Grid>
                                <Grid
                                  container
                                  className="font-20 font-weight-bold text-primary font-DBHeavent pt-2 pb-2"
                                >
                                  <Grid>
                                    {translations?.[lang]?.sign?.upload_title}
                                  </Grid>
                                  <Grid className="pl-2"></Grid>
                                  <Grid className="font-18">
                                    {
                                      translations?.[lang]?.sign
                                        ?.upload_request_type
                                    }
                                  </Grid>
                                </Grid>
                                <Grid>
                                  <Grid
                                    className="image-snap-card"
                                    style={{
                                      backgroundImage:
                                        "url(" + uploadFileRef + ")",
                                    }}
                                  >
                                    <label htmlFor="contained-button-file">
                                      <Input
                                        accept=".jpg, .png"
                                        id="contained-button-file"
                                        multiple
                                        onChange={uploadFile}
                                        onClick={(event) => {
                                          event.target.value = null;
                                        }}
                                        type="file"
                                      />
                                      <Button
                                        component="span"
                                        className={clsx(
                                          uploadFileRef
                                            ? "btn-snap-card-img"
                                            : "btn-snap-card",
                                        )}
                                      >
                                        <CardMedia
                                          style={{
                                            display: uploadFileRef
                                              ? "none"
                                              : "block",
                                          }}
                                          component="img"
                                          className="icon-photo"
                                          image="../../images/photo.png"
                                          alt="photo"
                                        />
                                      </Button>
                                      <Grid
                                        className="text-snap-card font-20 font-DBHeavent text-primary"
                                        style={{
                                          display: uploadFileRef ? "none" : "",
                                        }}
                                      >
                                        {translations?.[lang]?.sign?.upload}
                                      </Grid>
                                    </label>
                                  </Grid>
                                  <Grid>
                                    <CardMedia
                                      style={{
                                        display: uploadFileRef
                                          ? "block"
                                          : "none",
                                      }}
                                      component="img"
                                      className="icon-photo-water"
                                      image="../../images/waterMark2.png?v=4"
                                      alt="photo"
                                    />
                                  </Grid>
                                </Grid>
                              </Grid>
                            }
                          />{" "}
                          <ButtonRight
                            isDisbled
                            disbled={isCheck}
                            text={
                              editUrl
                                ? "บันทึกการแก้ไข"
                                : translations?.[lang]?.home?.next
                            }
                            onNextPage={handleNext}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </>
      )}
    </>
  );
};

export default memo(AttachSign);
